import { Link } from "@/router";

/*
 * The checks on the file are the four things a review actually looks at, and
 * the verdicts are deliberately mixed. A specimen report where everything
 * passes is an advertisement; one with a failure on it is the argument for
 * buying the hour.
 */
const CHECKS = [
  { name: "Security posture", verdict: "Fail", tone: "fail" },
  { name: "Search visibility", verdict: "At risk", tone: "warn" },
  { name: "Code quality", verdict: "Pass", tone: "pass" },
  { name: "Checkout path", verdict: "At risk", tone: "warn" },
] as const;

export function Hero() {
  return (
    <section id="top" className="k-shell k-hero">
      <div>
        <p className="k-eyebrow">Case file · Customer-facing systems</p>

        <h1>
          Every business deserves a{" "}
          <span className="k-mark">second opinion.</span>
        </h1>

        {/*
          Forty-one words down to twenty-four, and the mid-sentence bold is
          gone. The analogy still opens it because that is the hook, but the
          long form of it now lives in one place — the pricing card made the
          same argument in the same words further down the page, and reading
          it twice made the hero feel like preamble.
        */}
        <p className="k-lede">
          A car gets a tune-up. A patient gets a second opinion. Your company
          should get one before it bets on the systems your customers touch.
        </p>

        <div className="k-cta-row">
          <Link className="k-btn" href="/contact">
            Book a diagnostic hour — $125/hr
          </Link>
          <a className="k-jump" href="#services">
            See the packages ↓
          </a>
        </div>

        <p className="k-note">
          No retainer, no lock-in. One hour, one straight answer.
        </p>
      </div>

      <div className="k-stage">
        <div className="k-file">
          <div className="k-file__head">
            <span className="k-file__ref">
              File KG-0412 · Customer-facing systems
            </span>
            <span className="k-file__status">Status: needs second opinion</span>
          </div>

          <div className="k-file__body">
            {CHECKS.map((check) => (
              <div key={check.name} className="k-check">
                <span>{check.name}</span>
                <span className={`k-check__verdict k-check__verdict--${check.tone}`}>
                  {check.verdict}
                </span>
              </div>
            ))}
          </div>

          <div className="k-file__foot">
            <div className="k-file__line">
              <b>One diagnostic hour</b>
              <span className="k-file__price">$125</span>
            </div>
          </div>
        </div>

        <p className="k-stamp" aria-hidden="true">
          Certified
          <br />
          independent
          <br />
          review
        </p>
      </div>
    </section>
  );
}
